import { buildChildrenByParent } from "./chatbotTreeModel";
import { findInicioSlot } from "./chatbotSlotParentUtils";

export function findInicioSlotId(slots = []) {
  const inicio = findInicioSlot(slots);
  return inicio ? String(inicio.id) : null;
}

/** Profundidade a partir do passo Início (Início = 0). Retorna null se não estiver nessa subárvore. */
export function buildDepthsFromInicio(slots = []) {
  const childrenByParent = buildChildrenByParent(slots);
  const inicioId = findInicioSlotId(slots);
  const depths = new Map();
  if (!inicioId) return depths;

  const queue = [[inicioId, 0]];
  while (queue.length) {
    const [id, depth] = queue.shift();
    depths.set(id, depth);
    for (const child of childrenByParent.get(id) || []) {
      queue.push([String(child.id), depth + 1]);
    }
  }
  return depths;
}

/**
 * Por padrão: Início visível + filhos diretos visíveis; demais níveis recolhidos.
 * Recolhe todo passo com filhos a partir do 1º nível abaixo de Início.
 */
export function computeDefaultCollapsedIds(slots = []) {
  const childrenByParent = buildChildrenByParent(slots);
  const depths = buildDepthsFromInicio(slots);
  const collapsed = new Set();

  for (const slot of slots || []) {
    const id = String(slot.id);
    const hasChildren = (childrenByParent.get(id) || []).length > 0;
    if (!hasChildren) continue;

    const depth = depths.get(id);
    if (depth != null) {
      if (depth >= 1) collapsed.add(id);
      continue;
    }

    const parentId = Number(slot.id_pai) || 0;
    if (parentId !== 0) collapsed.add(id);
  }

  return collapsed;
}

export function countHiddenDescendants(nodeId, collapsedIds, childrenByParent) {
  const id = String(nodeId);
  if (!collapsedIds?.has?.(id)) return 0;

  let count = 0;
  const walk = (currentId) => {
    for (const child of childrenByParent.get(String(currentId)) || []) {
      count += 1;
      walk(String(child.id));
    }
  };
  walk(id);
  return count;
}

export function isNodeVisible(nodeId, collapsedIds, childrenByParent, slotById) {
  let current = slotById.get(String(nodeId));
  while (current) {
    const parentId = Number(current.id_pai) || 0;
    if (parentId === 0) return true;
    const parentKey = String(parentId);
    if (collapsedIds?.has?.(parentKey)) return false;
    current = slotById.get(parentKey);
  }
  return true;
}
